<template>
  <div class="dots mb-4 text-center">
    <span v-for="item in 5" ref="indicators" class="dots__item"
      :class="{ 'dots__item--active': item <= activeDots }" :key="item.id"></span>
  </div>
</template>

<script>
export default {
  props: ['activeDots'],
};
</script>

<style lang="scss" scoped>
.dots {
  &__item {
    background: #fff;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 8px;
    margin-left: 3px;
    margin-right: 3px;
    &--active {
      background: #78be20;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Evaluation/Dots.vue